import * as React from 'react';
import {
  Menu, MenuItem,
} from '@material-ui/core';

interface IRepairJobActionMenuProps {
  repairJobId: string;
  anchorEl: HTMLElement;
  handleDeleteRepairJob: (id: string) => void;
  handleOpenEditRepairJob: (id: string) => void;
  handleClose: () => void;
}

const RepairJobActionMenu: React.FC<IRepairJobActionMenuProps> = (
  {
    repairJobId, anchorEl, handleDeleteRepairJob, handleOpenEditRepairJob, handleClose,
  },
) => (

  <Menu
    anchorEl={anchorEl}
    keepMounted
    open
    onClose={handleClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
  >
    <MenuItem id="delete-repair-job-button" onClick={() => handleDeleteRepairJob(repairJobId)}>{'Delete Repair Job'}</MenuItem>
    <MenuItem id="edit-repair-job-button" onClick={() => handleOpenEditRepairJob(repairJobId)}>{'Edit Repair Job'}</MenuItem>
  </Menu>
);

export default RepairJobActionMenu;
